import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-tickets-new-ticket-creation-card',
  templateUrl: './tickets-new-ticket-creation-card.component.html',
  styleUrls: ['./tickets-new-ticket-creation-card.component.scss']
})
export class TicketsNewTicketCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  selectedCenters;
  showButton;
  editorConfig: AngularEditorConfig;
  ticketHtmlPlaceholder: string;
  ticketTextPlaceholder: string;
  addNewTicketSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl(true),
    ticketName: new FormControl(null, Validators.required),
    ticketHtmlFlag: new FormControl(false),
    htmlContent: new FormControl(null),
    ticketTextFlag: new FormControl(false),
    textContent: new FormControl({ value: null, disabled: true })
  });
  constructor(private userStorageService: UserStorageService,
              private spinnerService: SpinnerService,
              private router: Router,
              private snackbarService: SnackBarService,
              private activatedRoute: ActivatedRoute,
              private ticketsService: TicketsService) {
                this.ticketHtmlPlaceholder = 'asd';
                this.ticketTextPlaceholder = '';
                this.showButton = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.editorConfig = {
      spellcheck: false,
      sanitize: false,
      height: '25rem',
      // minHeight: '5rem',
      placeholder: this.ticketHtmlPlaceholder,
      translate: 'no',
      uploadUrl: 'v1/images',
      customClasses: []
    };
  }

  public addNewTicket() {
    this.showButton = false;
    this.spinnerService.show('ticket-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewTicketSubscription = this.ticketsService.addNewTicket(this.basicDataForm.get('active').value, this.basicDataForm.get('ticketName').value, this.filterCentersInternalId(this.selectedCenters), this.basicDataForm.get('ticketTextFlag').value, this.basicDataForm.get('textContent').value, this.basicDataForm.get('ticketHtmlFlag').value, this.basicDataForm.get('htmlContent').value).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('ticket-new-spinner');
          this.router.navigate(['../tickets'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.showButton = true;
          this.spinnerService.hide('ticket-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('ticket-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('ticketName').valid) {
      return 'tickets-page.snackbar messages.name ticket error';
    } else if (!this.basicDataForm.get('ticketHtmlFlag').value && !this.basicDataForm.get('ticketTextFlag').value) {
      return 'tickets-page.snackbar messages.at least one ticket error';
    } else if (this.basicDataForm.get('ticketHtmlFlag').value && !this.basicDataForm.get('htmlContent').value) {
      return 'tickets-page.snackbar messages.empty html ticket error';
    } else if (this.basicDataForm.get('ticketTextFlag').value && !this.basicDataForm.get('textContent').value) {
      return 'tickets-page.snackbar messages.empty text ticket error';
    } else {
      return true;
    }
  }

  public centersDuallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
    }
  }

  public htmlStatus() {
    if (this.basicDataForm.get('ticketHtmlFlag').value) {
      this.editorConfig.editable = true;
    } else {
      this.editorConfig.editable = false;
    }
  }

  public textStatus() {
    if (this.basicDataForm.get('ticketTextFlag').value) {
      this.basicDataForm.get('textContent').enable();
    } else {
      this.basicDataForm.get('textContent').disable();
    }
  }

  public cancelTicket() {
    this.router.navigate(['../tickets'], { relativeTo: this.activatedRoute.parent });
  }

  private filterCentersInternalId(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map(c => c.InternalId);
    } else {
      return [];
    }
  }

  ngOnDestroy() {
    if (this.addNewTicketSubscription) { this.addNewTicketSubscription.unsubscribe(); }
  }

}
